<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> EDIÇÃO DE NOTAS CONCILIADAS </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <alert
        :type="typeAlert"
        :visible="showAlert"
        :message="messageAlert"
        :clickClose="() => (showAlert = false)"
      ></alert>
      <v-form
        ref="form"
        v-model="valid"
        :lazy-validation="lazy"
        class="compact-form"
      >
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="4" lg="3" class="py-1">
              <v-select
                :items="providers"
                :item-text="(item) => `${item.code} - ${item.description}`"
                item-value="id"
                v-model="provider"
                label="Fornecedor"
                hide-details
                clearable
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="4" lg="3" class="py-1">
              <v-select
                :items="companies"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                v-model="company"
                label="Franqueado"
                hide-details
                clearable
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="2" class="py-1">
              <v-btn
                dark
                color="blue darken-3"
                small
                class="mt-1"
                @click="loadInvoices()"
              >
                <v-icon> mdi-plus </v-icon>
                Carregar Notas Fiscais
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1">
              <v-card outlined rounded>
                <v-toolbar
                  color="blue darken-4"
                  class="font-weight-bold subtitle-2"
                  height="28"
                  dense
                  outlined
                  flat
                  dark
                  >NOTAS FISCAIS PARA FATURAMENTO</v-toolbar
                >
                <v-card-text>
                  <v-row>
                    <v-col class="py-1">
                      <v-simple-table dense fixed-header height="400">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left text-no-wrap" width="15%">
                                Fornecedor
                              </th>
                              <th class="text-left text-no-wrap" width="15%">
                                Franqueado
                              </th>
                              <th class="text-left text-no-wrap">Emissão</th>
                              <th class="text-left text-no-wrap">
                                Nota Fiscal
                              </th>
                              <th class="text-left text-no-wrap">Lançamento</th>
                              <th class="text-right text-no-wrap">
                                Vr. Produtos
                              </th>
                              <th class="text-right text-no-wrap">Qt. Total</th>
                              <th class="text-right text-no-wrap">
                                Vr. Total Nota
                              </th>
                              <th class="text-right text-no-wrap">
                                Vr. Descontos
                              </th>
                              <th class="text-right text-no-wrap">
                                Vr. Acréscimos
                              </th>
                              <th class="text-left text-no-wrap">Nº Pedidos</th>
                              <th class="text-left text-no-wrap" width="60px">
                                Ação
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="invoice in invoices" :key="invoice.id">
                              <td>
                                {{ invoice.provider.code }} -
                                {{ invoice.provider.description }}
                              </td>
                              <td>
                                {{ invoice.franchise.code }} -
                                {{ invoice.franchise.name }}
                              </td>
                              <td>{{ invoice.issue_date | dateToBr }}</td>
                              <td class="text-left">
                                {{ invoice.number }}-{{ invoice.serie }}
                              </td>
                              <td>{{ invoice.invoice_date | dateToBr }}</td>
                              <td class="text-right">
                                {{ invoice.value | currencyEuaToBr }}
                              </td>
                              <td class="text-right">{{ invoice.quantity }}</td>
                              <td class="text-right">
                                {{ invoice.value_total | currencyEuaToBr }}
                              </td>
                              <td class="text-right">
                                {{ invoice.discount | currencyEuaToBr }}
                              </td>
                              <td class="text-right">
                                {{ invoice.addition | currencyEuaToBr }}
                              </td>
                              <td>{{ invoice.orders.length }}</td>
                              <td>
                                <v-tooltip top color="blue">
                                  <!-- eslint-disable-next-line -->
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      color="blue darken-1"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="editInvoice(invoice)"
                                    >
                                      mdi-pencil
                                    </v-icon>
                                  </template>
                                  <span>Editar</span>
                                </v-tooltip>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>
<script>
import { URL } from "@/api/config";

import * as CompanyAPI from "@/api/requests/CompanyRequest";

import Alert from "@/components/Alert";
import AwesomeMask from "awesome-mask";

export default {
  components: { Alert },
  directives: {
    mask: AwesomeMask,
  },
  data: () => ({
    companies: [],
    company: "",
    loading: false,
    showAlert: false,
    messageAlert: false,
    typeAlert: "error",
    lazy: false,
    valid: true,
    invoices: [],
    providers: [],
    provider: "",
  }),
  computed: {},
  created() {
    this.initialize();
  },
  filters: {
    currencyEuaToBr: function (value) {
      if (!value) return "0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    dateToBr: function (date) {
      if (date == undefined) return "";
      return date.split("-").reverse().join("/");
    },
  },
  methods: {
    async initialize() {
      this.getCompanies();
    },
    async getCompanies() {
      // this.loading = true;
      try {
        let data = await CompanyAPI.getAll();
        this.companies = data
          .filter((item) => item.type === "fra" || item.type === "mul")
          .sort((a, b) => (a.code > b.code ? 1 : -1));
        this.providers = data
          .filter((item) => item.type === "for")
          .sort((a, b) => (a.code > b.code ? 1 : -1));
      } catch (error) {
        this.companies = [];
        console.log(error);
      } finally {
        // this.loading = false;
      }
    },
    async loadInvoices() {
      if (
        ((this.company === "" || this.company === null) &&
          this.provider === "") ||
        this.provider === null
      ) {
        this.showAlert = true;
        this.typeAlert = "error";
        this.messageAlert =
          "Selecione um Fornecedor ou Franqueado para poder carregar as notas fiscais para faturamento";
        return;
      }

      this.loading = true;
      this.showAlert = false;
      this.provider = this.provider === null ? "" : this.provider;
      this.company = this.company === null ? "" : this.company;
      try {
        let res = await fetch(
          `${URL}invoice?franchise=${this.company}&provider=${this.provider}`
        );
        if (!res.ok) {
          throw new Error(res.message);
        }
        let data = await res.json();
        if (data.length === 0) {
          this.typeAlert = "warning";
          this.messageAlert = "Não existem notas conciliadas para editar";
          this.showAlert = true;
          this.$vuetify.goTo(0, {
            duration: 300,
            offset: 0,
            easing: "easeInOutCubic",
          });
        }
        this.invoices = data;
      } catch (error) {
        this.typeAlert = "error";
        this.messageAlert =
          "Houve um problema ao carregar as notas, tente novamente mais tarde";
        this.showAlert = true;
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
      } finally {
        this.loading = false;
      }
    },
    filterByRestitution(data, restitution) {
      return data
        .map((item) => ({
          ...item,
          orders: item.orders.filter((ord) => ord.restitution == restitution),
        }))
        .filter((item) => item.orders.length > 0)
        .map((item) => ({
          ...item,
          quantity: item.orders
            .map((ord) => ord.quantity_served)
            .reduce((prev, curr) => parseInt(prev) + parseInt(curr), 0),
          value: item.orders
            .map((ord) => ord.value_served)
            .reduce((prev, curr) => parseFloat(prev) + parseFloat(curr), 0)
            .toFixed(2),
        }));
    },
    getTotalSum(field) {
      let total = this.invoices.reduce(
        (prev, curr) =>
          prev +
          (!isNaN(parseFloat(curr[field])) ? parseFloat(curr[field]) : 0),
        0
      );

      let decimal_fields = ["value"];

      return !decimal_fields.includes(field)
        ? parseInt(total)
        : total.toFixed(2);
    },
    getValueRoyalties() {
      return this.invoices
        .map(
          (item) => parseFloat(item.value) * (parseFloat(item.royalties) / 100)
        )
        .reduce((prev, curr) => prev + curr, 0);
    },
    getValueTotal() {
      return this.invoices
        .map(
          (item) => parseFloat(item.value) * (parseFloat(item.royalties) / 100)
        )
        .reduce((prev, curr) => prev + curr, 0);
    },
    editInvoice(invoice) {
      console.log(invoice);
      this.$router.push({
        name: "ConciliationOrder",
        params: {
          franchise_id: invoice.franchise_id,
          provider_id: invoice.provider_id,
          number: invoice.number,
          serie: invoice.serie,
        },
      });
    },
  },
};
</script>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11.5px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}
.compact-form .fs-12 {
  transform: scale(0.75);
  transform-origin: left;
}
.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}
</style>
<style>
.text-field-uppercase input,
.text-field-uppercase textarea {
  text-transform: uppercase;
}
</style>
